function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M400.105,118.415c-0.005,0-0.013,0-0.02,0H297.673c-4.695,0-8.501-3.806-8.501-8.501V7.502 c0-3.438,2.071-6.538,5.248-7.854c3.177-1.316,6.832-0.589,9.265,1.843l102.075,102.075c1.747,1.557,2.847,3.824,2.847,6.349 C408.606,114.61,404.8,118.415,400.105,118.415z M306.174,101.413h73.388l-73.388-73.388V101.413z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M502.499,408.587H41.64c-4.695,0-8.501-3.806-8.501-8.501V195.259c0-4.695,3.806-8.501,8.501-8.501h460.859 c4.695,0,8.501,3.806,8.501,8.501v204.826C511,404.78,507.194,408.587,502.499,408.587z M50.141,391.584h443.857V203.76H50.141 C50.141,203.76,50.141,391.584,50.141,391.584z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M203.793,374.449c-23.511,0-42.638-19.127-42.638-42.639c0-4.695,3.806-8.501,8.501-8.501c4.695,0,8.501,3.806,8.501,8.501 c0,14.137,11.5,25.637,25.636,25.637c14.136,0,25.636-11.5,25.636-25.637c0-14.136-11.5-25.636-25.636-25.636 c-23.511,0-42.638-19.127-42.638-42.64c0-23.511,19.127-42.638,42.638-42.638s42.638,19.127,42.638,42.638 c0,4.695-3.806,8.501-8.501,8.501c-4.695,0-8.501-3.806-8.501-8.501c0-14.136-11.5-25.636-25.636-25.636 c-14.136,0-25.636,11.5-25.636,25.636c0,14.137,11.5,25.637,25.636,25.637c23.511,0,42.638,19.127,42.638,42.638 C246.432,355.322,227.304,374.449,203.793,374.449z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M400.085,511H7.501C2.806,511-1,507.193-1,502.499V7.502c0-4.695,3.806-8.501,8.501-8.501h290.171 c4.695,0,8.501,3.806,8.501,8.501v93.912h93.911c4.695,0,8.501,3.806,8.501,8.501v85.344c0,4.695-3.806,8.501-8.501,8.501H50.14 v187.824h349.945c4.695,0,8.501,3.806,8.501,8.501v102.413C408.586,507.193,404.78,511,400.085,511z M16.002,493.998h375.581 v-85.411H41.638c-4.695,0-8.501-3.806-8.501-8.501V195.259c0-4.695,3.806-8.501,8.501-8.501h349.945v-68.343h-93.911 c-4.695,0-8.501-3.806-8.501-8.501V16.002H16.002V493.998z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M101.38,374.449c-18.805,0-34.104-15.3-34.104-34.105c0-4.695,3.806-8.501,8.501-8.501c4.695,0,8.501,3.806,8.501,8.501 c0,9.431,7.672,17.103,17.102,17.103s17.102-7.672,17.102-17.103V237.931c0-4.695,3.806-8.501,8.501-8.501s8.501,3.806,8.501,8.501 v102.413C135.485,359.149,120.186,374.449,101.38,374.449z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M314.741,374.449h-8.534c-18.805,0-34.105-15.3-34.105-34.105V255c0-18.805,15.3-34.104,34.105-34.104h8.534 c18.805,0,34.104,15.299,34.104,34.104v85.344C348.845,359.149,333.546,374.449,314.741,374.449z M306.207,237.898 c-9.431,0-17.103,7.672-17.103,17.102v85.344c0,9.431,7.672,17.103,17.103,17.103h8.534c9.43,0,17.102-7.672,17.102-17.103V255 c0-9.43-7.672-17.102-17.102-17.102L306.207,237.898L306.207,237.898z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M468.361,374.45c-2.877,0-5.627-1.466-7.209-3.997l-69.634-111.414v106.91c0,4.695-3.806,8.501-8.501,8.501 s-8.501-3.806-8.501-8.501V229.396c0-3.792,2.512-7.126,6.157-8.171c3.65-1.046,7.542,0.45,9.553,3.666l69.634,111.414v-106.91 c0-4.695,3.806-8.501,8.501-8.501c4.695,0,8.501,3.806,8.501,8.501v136.552c0,3.792-2.512,7.126-6.157,8.172 C469.927,374.342,469.139,374.45,468.361,374.45z"
});

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var SvgJson = function SvgJson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE100"
    },
    points: "135.518,400.086 135.518,195.259 400.086,195.259 400.086,109.915 297.673,109.915  297.673,7.502 7.501,7.502 7.501,502.499 400.086,502.499 400.086,400.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFA800"
    },
    points: "374.482,502.499 400.086,502.499 400.086,109.915 374.482,109.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#63D3FD"
    },
    points: "41.639,400.086 502.499,400.086 502.499,195.259 41.639,195.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3DB9F9"
    },
    points: "476.896,400.086 502.499,400.086 502.499,195.259 476.896,195.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDCC00"
    },
    points: "400.086,109.915 297.673,109.915 297.673,7.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "7.501,502.499 33.104,502.499 33.104,7.502 7.501,7.502  "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/json.5d9536c5.svg";
export { ForwardRef as ReactComponent };